import { QueryClient } from "@tanstack/react-query";
import { PublicAppError } from "../shared/lib/errors";

/** Repetir uma negação de RLS, um cancelamento ou uma expiração só gasta rede. */
const FINAL_CODES = new Set([
  "forbidden",
  "unauthorized",
  "conflict",
  "invalid_input",
  "request_cancelled",
  "request_timeout",
]);

function isFinal(error: unknown): boolean {
  if (error instanceof PublicAppError) return FINAL_CODES.has(error.code);
  return error instanceof Error && /cancel|forbidden|unauthorized/i.test(error.message);
}

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 5 * 60_000,
        retry: (failureCount, error) => failureCount < 1 && !isFinal(error),
        staleTime: 30_000,
      },
      mutations: { retry: false },
    },
  });
}
